<template>
  <div class="mx-auto text-center">
    <SpinningLoader :pending="true" />
  </div>
</template>

<script setup>
import { useAuth0 } from "@auth0/auth0-vue";
import * as Sentry from "@sentry/vue";
import { useJwt } from '@vueuse/integrations/useJwt'
import { inject, unref, watch } from "vue";
import { useRouter } from "vue-router";

import SpinningLoader from "@/components/SpinningLoader.vue";
import useAxios from "@/composables/axios";
import sse from '@/services/sse';
import { useAuthStore } from "@/stores/auth";
import { useClockStore } from "@/stores/clock";

const { user, getAccessTokenSilently } = useAuth0()

const authStore = useAuthStore()
const clock = useClockStore()
const axios = useAxios();
const router = useRouter();

const config = inject('config')

watch(user, async (to, from) => {

  if (to) {
    const jwt = await getAccessTokenSilently();
    const { payload } = useJwt(jwt)
    authStore.user = user.value
    authStore.payload = unref(payload)
    Sentry.setUser({ email: user.value.email });

    if (authStore.isAuthenticated) {
      sse.setConfig(config.AOL_API_URL, jwt);
      await sse.connect();

      await axios.get('/util/getServerTime').then(async (clockResponse) => {
        await clock.init(clockResponse.data.currentTime);
        clock.start();
      }).catch(() => {
        
      });

    }

    router.replace({ path: '/aste' })

  } else {
    router.replace({ path: '/' })
  }
})

</script>